import { Injectable } from "@angular/core";
import { RestService } from "../core/core/rest.service";
import { ProjectListRow, Project, ProjectType, ProjectRow, ProjectWatcher, ProjectStep, ProjectStepIssue, ProjectStepWorklog, ProjectStepRow } from "./projects.model";
import { ObjectToSelect } from "../core/shared/objectToSelect.model";
import { Employee } from "../company/employees/employee.model";
import { CustomersListModule } from "../company/customers/customers-list/customers-list.module";

@Injectable()
export class ProjectsRest {
    constructor(private http: RestService) { }

    public getProjects(projectType: string, stateId: number, projectManagerId: string) {
        return this.http.post<ProjectListRow[]>(`api/projects/grid/${projectType}/${stateId}/${projectManagerId}`, {});
    }

    public getProjectTypes() {
        return this.http.get<ObjectToSelect[]>('api/projects/getTypes');
    }

    public getProjectManagers() {
        return this.http.get<ObjectToSelect[]>('api/projects/getProjectManagers');
    }

    public getStates() {
        return this.http.get<ObjectToSelect[]>('api/projects/getStates');
    }

    public getProject(id: number, projectType: ProjectType) {
        return this.http.get<Project>(`api/projects/project/${id}/${projectType}`);
    }

    public getEmployees() {
        return this.http.get<ObjectToSelect[]>('api/projects/getEmployees');
    }

    public getSystemVersions() {
        return this.http.get<ObjectToSelect[]>('api/projects/getSystemVersions');
    }

    public saveProject(project: Project) {
        return this.http.post<number>('api/projects/save', project);
    }

    public getProjectByName(data: {id: number, value: string}) {
        return this.http.post<ProjectRow[]>(`api/projects/rows`,  data);
    }

    public getProjectByStepName(data: {id: number, value: string}) {
        return this.http.post<ProjectRow[]>(`api/projects/rows/step`, data);
    }

    public addProjectWatchers(projectId: number, selectedEmployees: number[]) {
        return this.http.post<boolean>(`api/projects/addprojectwatchers/${projectId}`, selectedEmployees);
    }

    public removeProjectWatcher(projectWatcherId: number) {
        return this.http.post<boolean>(`api/projects/removeprojectwatcher/${projectWatcherId}`, {});
    }

    public getProjectStep(id: number, projectId: number, customerId: number) {
        return this.http.get<ProjectStep>(`api/projects/getprojectstep/${id}/${projectId}/${customerId}`);
    }

    public deleteProjectStep(id: number) {
        return this.http.post(`api/projects/deleteprojectstep/${id}`, {});
    }

    public getCustomerVstsEpics(customerId: number) {
        return this.http.get(`api/projects/getcustomervstsepics/${customerId}`);
    }

    public getProjectStepStates() {
        return this.http.get<ObjectToSelect[]>('api/projects/getprojectstepstates');
    }

    public saveProjectStep(projectStep: ProjectStep) {
        return this.http.post('api/projects/saveprojectstep', projectStep);
    }

    public getRelatedProjectStepIssues(projectStepId: number) {
        return this.http.get<ProjectStepIssue[]>(`api/projects/getprojectsteprelatedissues/${projectStepId}`);
    }

    public getRelatedProjectStepWorklogs(projectStepId: number) {
        return this.http.get<ProjectStepWorklog[]>(`api/projects/getprojectsteprelatedworklogs/${projectStepId}`);
    }
    public deleteProject(projectId: number) {
        return this.http.post(`api/projects/delete/${projectId}`, {});
    }

    public getProjectStepRows(projectId: number) {
        return this.http.post<ProjectStepRow[]>(`api/projects/getprojectsteps/${projectId}`, {});
    }

    public checkHasProjectSteps(projectId: number) {
        return this.http.post<boolean>(`api/projects/checkhasprojectsteps/${projectId}`, {});
    }

    public getAreaPaths(){
        return this.http.get<ObjectToSelect[]>('api/projects/getareapaths');
    }

    public getCustomerProjectStepsForIssue(customerId: number, issueId: number) {
        return this.http.get<ObjectToSelect[]>(`api/projects/getCustomerProjectStepsForIssue/${customerId}/${issueId}`);
    }

    public getCustomerProjectStepsForWorklog(customerId: number, worklogId: number) {
        return this.http.get<ObjectToSelect[]>(`api/projects/getCustomerProjectStepsForWorklog/${customerId}/${worklogId}`);
    }

    public getProjectWatchersByProjectStepId(projectStepId: number) {
        return this.http.get<ProjectWatcher[]>(`api/projects/getProjectWatchersByProjectStepId/${projectStepId}`);
    }
}
